import { render, staticRenderFns } from "./linkButton.vue?vue&type=template&id=002a6f6c&scoped=true&"
import script from "./linkButton.vue?vue&type=script&lang=js&"
export * from "./linkButton.vue?vue&type=script&lang=js&"
import style0 from "./linkButton.vue?vue&type=style&index=0&id=002a6f6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002a6f6c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
